/* Bastuexperten - Custom Options JS v13 */
document.addEventListener("DOMContentLoaded", function() {

  var colorMap = {
    "Svart": "#0A0A0A",
    "Antracitgr": "#293133",
    "Falur": "#801818",
    "rkbrun": "#3C2415",
    "Olivgr": "#4A5A2B",
    "Obehandlad": "#D4C9B0",
    "– grå": "#8C8C7C",
    "– brun": "#6B4226",
    "– antracit": "#383E42",
    "– vit": "#F0EEE8"
  };

  var transparentColor = "#C4A56E";

  /* --- Info bubble text per option section label --- */
  var optionInfoText = {
    "Kaminskydd": "Kaminskydd (eldsk\u00e4rm) kr\u00e4vs f\u00f6r vedeldade kaminer \u2014 det f\u00f6rhindrar att gnistor n\u00e5r tr\u00e4v\u00e4ggarna. V\u00e4lj r\u00e4tt typ baserat p\u00e5 ditt aggregat.",
    "Termometer/hygrometer": "M\u00e4ter temperatur och luftfuktighet inne i bastun. Praktiskt f\u00f6r att h\u00e5lla koll p\u00e5 bastub\u00e5ngan.",
    "Inv\u00e4ndig primer": "Klar grundf\u00e4rg f\u00f6r bastuns insida. Skyddar tr\u00e4et mot fukt och f\u00f6rl\u00e4nger livsl\u00e4ngden.",
    "Vattentank": "22\u00a0L rostfri vattentank att h\u00e4nga vid ugnen. Ger varmt vatten f\u00f6r att h\u00e4lla p\u00e5 kaminen och skapa \u00e5nga. Ing\u00e5r ej i Harvia\u00a0M3-paketet.",
    "Ryggst\u00f6d": "Ergonomiskt ryggst\u00f6d f\u00e4st mot b\u00e4nken. \u00d6kar komforten under l\u00e4ngre bastusessioner.",
    "Nackst\u00f6d": "Nackst\u00f6d som f\u00e4sts mot ryggst\u00f6det f\u00f6r extra vila och avslappning.",
    "Tr\u00e4hink & Slev": "Klassisk tr\u00e4hink med tr\u00e4slev av bj\u00f6rktr\u00e4. Anv\u00e4nds f\u00f6r att h\u00e4lla vatten p\u00e5 kaminen."
  };

  /* --- Add info bubbles to option section headers --- */
  function injectInfoBubbles() {
    /* Collapsible select-type headers (button elements) */
    document.querySelectorAll(".custom-option-section .collapsible-trigger-btn").forEach(function(btn) {
      var labelSpan = btn.querySelector(".option-name");
      if (!labelSpan) return;
      var labelText = labelSpan.textContent.trim();
      var infoText = optionInfoText[labelText];
      if (!infoText) return;
      if (btn.querySelector(".option-info-btn")) return; /* already injected */

      var bubble = document.createElement("span");
      bubble.className = "option-info-btn";
      bubble.setAttribute("aria-label", "Mer information");
      bubble.textContent = "i";

      var tooltip = document.createElement("span");
      tooltip.className = "option-tooltip";
      tooltip.textContent = infoText;
      bubble.appendChild(tooltip);

      /* Touch support: toggle active class */
      bubble.addEventListener("click", function(e) {
        e.stopPropagation();
        bubble.classList.toggle("active");
      });

      labelSpan.parentNode.insertBefore(bubble, labelSpan.nextSibling);
    });

    /* Non-collapsible checkbox section headers (div.collapsible-trigger-btn) */
    document.querySelectorAll(".custom-option-section.multiple-options > .collapsible-trigger-btn").forEach(function(div) {
      var labelText = div.textContent.trim();
      var infoText = optionInfoText[labelText];
      if (!infoText) return;
      if (div.querySelector(".option-info-btn")) return;

      var bubble = document.createElement("span");
      bubble.className = "option-info-btn";
      bubble.setAttribute("aria-label", "Mer information");
      bubble.textContent = "i";

      var tooltip = document.createElement("span");
      tooltip.className = "option-tooltip";
      tooltip.textContent = infoText;
      bubble.appendChild(tooltip);

      bubble.addEventListener("click", function(e) {
        e.stopPropagation();
        bubble.classList.toggle("active");
      });

      div.appendChild(bubble);
    });
  }

  injectInfoBubbles();

  /* --- Color dots for radio options --- */
  document.querySelectorAll('.custom-option input[type="radio"], .custom-option input[type="checkbox"]').forEach(function(input) {
    var name = input.getAttribute("data-name") || "";
    var label = input.nextElementSibling;
    if (!label || !label.classList.contains("selector-block")) return;
    var nameEl = label.querySelector(".option-name");
    if (!nameEl) return;

    if (name.indexOf("ThermoWood") !== -1) {
      var badge = document.createElement("span");
      badge.className = "popular-badge";
      badge.textContent = "Mest popul\u00e4r";
      nameEl.appendChild(badge);
    }

    if (name.toLowerCase().indexOf("transparent") !== -1) {
      var dot = document.createElement("span");
      dot.className = "color-dot";
      dot.style.backgroundColor = transparentColor;
      nameEl.insertBefore(dot, nameEl.firstChild);
      return;
    }

    for (var key in colorMap) {
      if (name.indexOf(key) !== -1) {
        var dot = document.createElement("span");
        dot.className = "color-dot";
        dot.style.backgroundColor = colorMap[key];
        nameEl.insertBefore(dot, nameEl.firstChild);
        break;
      }
    }
  });

  /* --- Dynamic Ytbehandling logic (bastutunna products) --- */
  var ytbehandlingSection = null;
  var ytbehandlingHeader = null;
  var transparentPaidOption = null;
  var transparentFreeOption = null;
  var transparentFreeInput = null;
  var obehandladOption = null;
  var obehandladInput = null;

  document.querySelectorAll(".custom-option-section").forEach(function(section) {
    var header = section.querySelector(".option-name");
    if (header && (header.textContent.indexOf("Ytbehandling") !== -1 || header.textContent.indexOf("Yttre F") !== -1)) {
      ytbehandlingSection = section;
      ytbehandlingHeader = header;
      section.querySelectorAll('.custom-option').forEach(function(opt) {
        var inp = opt.querySelector('input[type="radio"]');
        if (!inp) return;
        var dn = inp.getAttribute("data-name") || "";
        if (dn === "Transparent") {
          transparentPaidOption = opt;
        } else if (dn.indexOf("Transparent") !== -1 && dn.indexOf("ing") !== -1) {
          transparentFreeOption = opt;
          transparentFreeInput = inp;
        } else if (dn.indexOf("Obehandlad") !== -1) {
          obehandladOption = opt;
          obehandladInput = inp;
        }
      });
    }
  });

  var materialRadios = [];
  var leveransRadios = [];

  document.querySelectorAll(".custom-option-section").forEach(function(section) {
    var header = section.querySelector(".option-name");
    if (!header) return;
    var txt = header.textContent;
    if (txt.indexOf("Material") !== -1) {
      materialRadios = section.querySelectorAll('input[type="radio"]');
    }
    if (txt.indexOf("Leverans") !== -1) {
      leveransRadios = section.querySelectorAll('input[type="radio"]');
    }
  });

  function getSelectedName(radios) {
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) return radios[i].getAttribute("data-name") || "";
    }
    return "";
  }

  function isThermoWood() {
    return getSelectedName(materialRadios).indexOf("ThermoWood") !== -1;
  }

  function isByggsats() {
    return getSelectedName(leveransRadios).indexOf("Byggsats") !== -1;
  }

  var originalHeaderText = ytbehandlingHeader ? ytbehandlingHeader.textContent.trim() : "";

  function updateYtbehandling() {
    if (!ytbehandlingSection) return;

    if (isByggsats()) {
      ytbehandlingSection.style.display = "none";
      if (obehandladInput) { obehandladInput.checked = true; obehandladInput.dispatchEvent(new Event("change", {bubbles: true})); }
      return;
    }

    ytbehandlingSection.style.display = "";

    if (isThermoWood() && transparentFreeOption) {
      if (ytbehandlingHeader) ytbehandlingHeader.textContent = "V\u00e4lj extra f\u00e4rg (lasyr + bastuvax ing\u00e5r)";
      if (obehandladOption) obehandladOption.style.display = "none";
      if (transparentPaidOption) transparentPaidOption.style.display = "none";
      if (transparentFreeOption) transparentFreeOption.style.display = "";
      var checked = ytbehandlingSection.querySelector('input[type="radio"]:checked');
      if (!checked || checked.closest(".custom-option").style.display === "none") {
        if (transparentFreeInput) { transparentFreeInput.checked = true; transparentFreeInput.dispatchEvent(new Event("change", {bubbles: true})); }
      }
    } else {
      if (ytbehandlingHeader) ytbehandlingHeader.textContent = originalHeaderText;
      /* Obehandlad is no longer offered as a colour. It stays in the data purely as
         the zero-price state the Byggsats branch above forces, so keep it hidden
         whenever the section is actually on screen. */
      if (obehandladOption) obehandladOption.style.display = "none";
      if (transparentPaidOption) transparentPaidOption.style.display = "";
      if (transparentFreeOption) transparentFreeOption.style.display = "none";
      if ((transparentFreeInput && transparentFreeInput.checked) ||
          (obehandladInput && obehandladInput.checked)) {
        var resetInput = null;
        if (ytbehandlingSection) {
          var firstVisible = null;
          ytbehandlingSection.querySelectorAll('.custom-option').forEach(function(opt) {
            if (firstVisible) return;
            var inp = opt.querySelector('input[type="radio"]');
            if (inp && inp !== transparentFreeInput && inp !== obehandladInput && opt.style.display !== "none") firstVisible = inp;
          });
          resetInput = firstVisible;
        }
        if (resetInput) { resetInput.checked = true; resetInput.dispatchEvent(new Event("change", {bubbles: true})); }
      }
    }
  }

  if (transparentFreeOption) transparentFreeOption.style.display = "none";
  if (obehandladInput && ytbehandlingSection && !ytbehandlingSection.querySelector('input[type="radio"]:checked')) {
    obehandladInput.checked = true;
    obehandladInput.dispatchEvent(new Event("change", {bubbles: true}));
  }

  materialRadios.forEach(function(r) { r.addEventListener("change", updateYtbehandling); });
  leveransRadios.forEach(function(r) { r.addEventListener("change", updateYtbehandling); });
  updateYtbehandling();
});

/* --- v14: diameter-conditional option pricing ------------------------------
   Any option value price can carry a sibling metafield with the suffix _d235,
   e.g. options/extra_option_4_val_price_2_d235 = "price: 9990 | type: fixed".
   When the Diameter option is set to the XL value, that price replaces the
   base one on the input's data-price and in the visible label, and the running
   total recalculates. Products with no _d235 metafields are untouched.       */
(function () {
  var metaEl = document.getElementById("metaopts");
  if (!metaEl) return;
  var rows;
  try { rows = JSON.parse(metaEl.textContent); } catch (e) { return; }

  var SUF = "_d235";
  var alt = {}, base = {}, diameterKey = null;

  function cents(v) {
    var m = /price:\s*([\d.]+)/.exec(v || "");
    return m ? Math.round(parseFloat(m[1]) * 100) : null;
  }

  rows.forEach(function (r) {
    var k = r[0] || "", v = r[1] || "";
    if (/^extra_option_\d+$/.test(k) && v.indexOf("Diameter") === 0) diameterKey = k;
    if (k.indexOf("_val_price_") === -1) return;
    if (k.slice(-SUF.length) === SUF) {
      alt[k.slice(0, -SUF.length).replace("_val_price_", "_val_")] = cents(v);
    } else {
      base[k.replace("_val_price_", "_val_")] = cents(v);
    }
  });

  var ids = Object.keys(alt);
  if (!ids.length || !diameterKey) return;

  function isXL() {
    var d = document.querySelector('input[name="' + diameterKey + '"]:checked');
    return !!(d && (d.getAttribute("data-name") || "").indexOf("XL") !== -1);
  }

  function money(c) {
    try { return theme.Currency.formatMoney(c, theme.settings.moneyFormat); }
    catch (e) { return (c / 100).toLocaleString("sv-SE") + " kr"; }
  }

  function apply() {
    var xl = isXL();
    ids.forEach(function (id) {
      var inp = document.getElementById(id);
      if (!inp) return;
      var p = xl ? alt[id] : base[id];
      if (p === null || p === undefined) return;
      inp.setAttribute("data-price", p);
      /* jQuery caches .data('price') on first read and ignores setAttribute,
         and updateTotals() reads it through jQuery -- so update the cache too */
      if (window.jQuery) window.jQuery(inp).data("price", p);
      var lbl = document.querySelector('label[for="' + id + '"] .option-price');
      if (lbl) lbl.innerHTML = p > 0 ? money(p) : "";  /* formatMoney returns markup */
    });
  }

  /* capture phase so data-price is current before the theme's total handler runs */
  document.addEventListener("change", function (e) {
    if (e.target && e.target.name === diameterKey) apply();
  }, true);

  apply();
})();
